import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';
import { createQueryClient } from '@smena/ui';
import { router } from '@/app/router';
import './styles/globals.css';

const queryClient = createQueryClient();
const container = document.getElementById('root');
if (!container) throw new Error('#root не найден в index.html');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster theme="dark" richColors position="bottom-right" />
    </QueryClientProvider>
  </StrictMode>,
);
